import type {ConfiguratorFeatureResponseBody} from '@dms/api/new-vehicle';

import {STANDARD_INCLUSION} from './newVehicleLabels';

/** The trim includes the feature as standard equipment, so it is never a selected option (D72). */
export const isStandardFeature = (feature: ConfiguratorFeatureResponseBody, trimId: string) =>
  feature.trimInclusions.some(
    (inclusion) => inclusion.trimId === trimId && inclusion.inclusion === STANDARD_INCLUSION
  );
